//调仓记录
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createForm } from 'rc-form';
import Util from '../../util.js';
import NHeader from "../NHeaderjiaoyijilu";
import { ztcgjiaoyijiluxiangqing} from '../../action/investmentAction';
import NavigatorMain from '../NavigatorMain';
import { Picker, List, WhiteSpace, ListView } from 'antd-mobile/lib';
import '../css/Transferrecord.css'
import { hashHistory } from "react-router";
class Detailsofwarehouseadjustment extends Component {  
  constructor(props) {  
    super(props); 
    this.state = {
      loadingFlag: false,
        xinxi:[],
        xinxi1:[],
        timeType:"请选择业务类型",
        timeAll:false,
        businessType:"",
    } 
  }

  goBack() {
    hashHistory.goBack();
  }
  componentDidMount(){
    let { dispatch } = this.props;
    let _this = this;
    let data1 = {
      tradeRequestId:this.props.location.state.tradeRequestId,
  }
      dispatch(ztcgjiaoyijiluxiangqing(data1,this.callbackData.bind(this),_this))
  }
  callbackData(res){
    console.log(res)
    let data=res.filter(i=>i.businessType.substring(1,3)!=="29")
      this.setState({
        xinxi:data,
        xinxi1:data
      })
  }
    // 去除时间的时分秒
    timeFormat(date){
      let newDate=/\d{4}-\d{1,2}-\d{1,2}/g.exec(date)
      return newDate[0]
    }
    selectRight(){
        this.setState({
          timeAll:!this.state.timeAll
        })
      }
      jyTypeCallback(period,businessType){
        console.log(period,businessType)
      let flag;
      this.setState({
        loadingFlag:flag,
        timeAll:false,
        handleFlag:true,
        timeType:period,
      })
      if(period==="选择业务类型"){
        this.setState({
          xinxi:this.state.xinxi1
        })
      }else{
        let guolvshuju=this.state.xinxi1.filter(i=>i.businessType.substring(1,3)===businessType)
        this.setState({
          xinxi:guolvshuju
        })
      }
      }
  render() {
      let {timeAll,xinxi,timeType}=this.state;
      let {commission,confirmTimeStr,businessTimeStr,}=this.props.location.state
      return (  
        <div className="container">  
            <div className="NHeader_containertiaocang">
        <div className="NHeader_wraptiaocang">         
          <div className="NHeader_content">
            <div className="NHeader_goback" onClick={this.goBack}><img src={require('../../img/n_icon_goback@2x.png')} /></div>
            <div className="NHeader_title">交易详情</div>
            <div className="NHeader_sharetiaocang">
              <div style={{marginRight:5}} onClick={()=>{this.selectRight()}}>{timeType}</div>
              { timeAll?
            <img style={{height: 16 , width: 16}} src={require("../../imgs/iconshangla.png")}/>
            :
            <img style={{height: 16 , width: 16}} src={require("../../imgs/iconxiala.png")}/>
            }
            </div>
          </div>
        </div>
        </div>
   
          <div className="jiaoyixiangqingtiaocang"> 
          <div className="jiaouyixiangqingtoptiaocangxiangqing">
          <div className="jiaouyixiangqingtop1" >
            调仓信息
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">调仓时间</div>
            <div  className="jiaouyixiangqingtop2bottom">{businessTimeStr ?businessTimeStr:"--"}</div>
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">手续费</div>
            {
                confirmTimeStr == null ?
                <div className="jiaouyixiangqingtop2bottom">--</div>
                :
                <div  className="jiaouyixiangqingtop2bottom">{Util.thousandCount(commission)+ "元"}</div>
            }
          </div>
          <div className="jiaouyixiangqingtop2">
            <div  className="jiaouyixiangqingtop2top">确认完成时间</div>
            {
                confirmTimeStr == null ?
                <div className="jiaouyixiangqingtop2bottom">--</div>
                :
                <div  className="jiaouyixiangqingtop2bottom">{this.timeFormat(confirmTimeStr)}</div>
            }
          </div>
        
         </div>
      
        <div className="jiaouyixiangqingbottom">
         <div className="jiaouyixiangqingtop1">
          交易进度
          </div>
           <div style={{flex:1,display:"flex",flexDirection:"column"}}>
           {
           xinxi.map((item,index)=>{
               return(
                <div key={index} className="jiaouyixiangqingbottommingxitiaocang">
                <div className="jiaouyixiangqingbottommingxi1" >
                    <div className="jiaouyixiangqingbottommingxitiaocang1l">
                    {
                      item.businessType.substring(1,3) === "36" ?
                      <div className="jiaouyixiangqingbottommingxitiaocang1lz" style={{borderColor:"#5BA3F6",color:"#5BA3F6"}}>
                      转换
                  </div>:null
                    }
                    {
                      item.businessType.substring(1,3) === "22" ?
                      <div className="jiaouyixiangqingbottommingxitiaocang1lz" style={{borderColor:"#875426",color:"#875426"}}>
                      申购
                  </div>:null
                    }
                    {
                      item.businessType.substring(1,3) === "24" ?
                      <div className="jiaouyixiangqingbottommingxitiaocang1lz" style={{borderColor:"#FF9653",color:"#FF9653"}}>
                      赎回
                  </div>:null
                    }
                  {/* {
                      item.businessType === "029" ?
                      <div className="jiaouyixiangqingbottommingxitiaocang1lz" style={{borderColor:"#FF9653",color:"#FF9653"}}>
                      分红
                  </div>:null
                    } */}
                   {/* 转换 */}
                    {  item.businessType.substring(1,3) === "36" ?
                                         <div className="jiaouyixiangqingbottommingxitiaocang1r">
                                         <div style={{flexDirection:"row",alignItems:"center",display:"flex"}} >
                                         <div className="jiaouyixiangqingbottommingxitiaocang1ryuan" style={{backgroundColor:"#D8D8D8"}}></div>
                                         {item.fundName}
                                         </div>
                                         <div className="jiaouyixiangqingbottommingxitiaocang1rtu">
                                         <img className="jiaouyixiangqingbottommingxitiaocang1rtu" src={require("../../imgs/zhuanhuan.png")}/>
                                         </div>
                                         <div style={{alignItems:"center",flexDirection:"row",display:"flex"}} >
                                         <div className="jiaouyixiangqingbottommingxitiaocang1ryuan" style={{backgroundColor:"#B69271"}}></div>
                                         {item.targetFundName}
                                       </div>
                                 </div>
                        : <div className="jiaouyixiangqingbottommingxitiaocang1l1">
                        {item.fundName}
                        </div>            
                    }
                    </div>
                    {
                    item.confirmState ==="0" ?
                    <div className="jiaouyixiangqingbottommingxi1right">
                      <text style={{color:"#F8515C"}}>{item.confirmStateName}</text>
                    </div>
                    :
                    <div className="jiaouyixiangqingbottommingxi1right">
                        {    
                            item.confirmState ==="1" ?
                            <text style={{color:"#999999"}}>{item.confirmStateName}</text>
                            :
                            <div className="jiaouyixiangqingbottommingxi1right">
                              {
                                item.confirmState ==="2" ?
                              <text style={{color:"#B69271"}}>{item.confirmStateName}</text>
                                :
                                <div className="jiaouyixiangqingbottommingxi1right">
                                  {
                                    item.confirmState ==="9" ?
                                    <text style={{color:"#B69271"}}>等待确认</text>
                                    :
                                    null
                                  }
                                </div>
                              }
                          </div>
                        }
                    </div>
                    
                    }
                </div>
                {/* //申购 */}
                {  item.businessType.substring(1,3) === "22" ?
                   <div  className="jiaouyixiangqingbottommingxi2" >
                                  <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                                    <div className="jiaouyixiangqingbottommingxi2top" >
                                    <div className="jiaouyixiangqingbottommingxi2top1">
                                    <div  style={{color:"#999999"}}>申购金额</div>
                                    </div>
                                    <div style={{color:"#333333"}}>{item.applicationAmount ? Util.thousandCount(item.applicationAmount):""}</div>
                                    </div>
                                    <div className="jiaouyixiangqingbottommingxi2top">
                                    <div className="jiaouyixiangqingbottommingxi2top1">
                                    <div  style={{color:"#999999"}}>成交份额</div>
                                    </div>
                                  
                                    <div style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmVolume  === null  ? "--" : Util.thousandCount(item.confirmVolume):"--"}</div>
                                    
                                    </div>
                                  </div>
                                  <div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"flex-end",alignContent:"space-around"}}>
                                  <div className="jiaouyixiangqingbottommingxi2topxiamingzi">
                                    <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                                    <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                                    </div>
                                    <div className="jiaouyixiangqingbottommingxi2topxia">
                                    <div  style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmNav ? Util.thousandCount4(item.confirmNav): "--":"--"}</div>
                                    <div  style={{color:"#333333"}}>{item.confirmState ==="1" ?item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                                      </div>
                                  </div>
                              </div>:null
                }
                {/* 赎回 */}
                {
                  item.businessType.substring(1,3) === "24" ?
                  <div  className="jiaouyixiangqingbottommingxi2" >
                  <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                    <div className="jiaouyixiangqingbottommingxi2top" >
                    <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999"}}>赎回份额</div>
                    </div>
                    <div style={{color:"#333333"}}>{item.applicationVolume ? Util.thousandCount(item.applicationVolume):""}</div>
                    </div>
                    <div className="jiaouyixiangqingbottommingxi2top">
                    <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999"}}>到账金额</div>
                    </div>
                    <div style={{color:"#333333"}}>{item.confirmState ==="1" ?item.confirmAmount  == null  ? "--" : Util.thousandCount(item.confirmAmount)+"元":"--"}</div>
                    </div>
                  </div>
                  <div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"flex-end",alignContent:"space-around"}}>
                                  <div className="jiaouyixiangqingbottommingxi2topxiamingzi">
                                    <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                                    <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                                    </div>
                                    <div className="jiaouyixiangqingbottommingxi2topxia">
                                    <div  style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmNav ? Util.thousandCount4(item.confirmNav): "--":"--"}</div>
                                    <div  style={{color:"#333333"}}>{item.confirmState ==="1" ?item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                                      </div>
                   </div>
              </div>:null
                }
                {/* 分红 */}
                {/* {
                  item.businessType === "029" ?
                  <div  className="jiaouyixiangqingbottommingxi2zhuanhuan" >
                  <div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"space-between",alignItems:"center"}}>
                    <div className="jiaouyixiangqingbottommingxi2top" >
                    <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999"}}>分红份额</div>
                    </div>
                    {
                      item.dividendMethod === "0" ?
                      <div style={{color:"#333333"}}>{item.applicationVolume  ? item.applicationVolume + "份":"--"}</div>
                        :
                      <div style={{color:"#333333"}}>{item.applicationAmount  ? item.applicationAmount + "元":"--"}</div>
                    }
                    </div>
                    <div className="jiaouyixiangqingbottommingxi2top" >
                    <div className="jiaouyixiangqingbottommingxi2top1">
                    <div  style={{color:"#999999"}}>分红方式</div>
                    </div>
                      <div style={{color:"#333333"}}>{item.dividendMethodName}</div>
                    </div>
                  </div>
              </div>:null
                } */}
                {/* 转换 */}
                {  item.businessType.substring(1,3) === "36"?
                <div>
                  {
                    item.confirmState ==="1" ?
                    <div  className="jiaouyixiangqingbottommingxi2" >
                    <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                      <div className="jiaouyixiangqingbottommingxi2top" >
                      <div className="jiaouyixiangqingbottommingxi2top1">
                      <div  style={{color:"#999999"}}>转换份额</div>
                      </div>
                      <div style={{color:"#333333"}}>{item.applicationVolume ? Util.thousandCount(item.applicationVolume):""}</div>
                      </div>
                      <div className="jiaouyixiangqingbottommingxi2top">
                      <div className="jiaouyixiangqingbottommingxi2top1">
                      <div  style={{color:"#999999"}}>转入金额</div>
                      </div>
                      <div style={{color:"#333333"}}>{item.confirmState ==="1" ?item.confirmAmount ? Util.thousandCount(item.confirmAmount)+"元":"":"--"}</div>
                      </div>
                    </div>
                    <div style={{flex:1,display:"flex",flexDirection:"row",justifyContent:"flex-end",alignContent:"space-around"}}>
                                  <div className="jiaouyixiangqingbottommingxi2topxiamingzi">
                                    <div style={{color:"#999999",textAlign:"left"}}>成交净值</div>
                                    <div  style={{color:"#999999",textAlign:"left"}}>手续费</div>
                                    </div>
                                    <div className="jiaouyixiangqingbottommingxi2topxia">
                                    <div  style={{color:"#333333"}}>{item.confirmState ==="1" ? item.confirmNav ? Util.thousandCount4(item.confirmNav): "--":"--"}</div>
                                    <div  style={{color:"#333333"}}>{item.confirmState ==="1" ?item.commision ===null ? "--":Util.thousandCount(item.commision)+"元":"--" }</div>
                                      </div>
                   </div>
                </div>
                :
                <div  className="jiaouyixiangqingbottommingxi2zhuanhuan" >
                <div style={{flex:1,display:"flex",flexDirection:"column",justifyContent:"space-around"}}>
                  <div className="jiaouyixiangqingbottommingxi2top" >
                  <div className="jiaouyixiangqingbottommingxi2top1">
                  <div  style={{color:"#999999"}}>转换份额</div>
                  </div>
                  <div style={{color:"#333333"}}>{item.applicationVolume ? Util.thousandCount(item.applicationVolume):""}</div>
                  </div>
                </div>
            </div>
                  }
                </div>
                :null
                }
                <div className="jiaouyixiangqingbottommingxi4tiaocang">
                {item.confirmState==="0"||item.confirmState==="1"||item.confirmState==="2"||item.confirmState==="5" ?
                   <div>
                      {
                        item.confirmState ==="0" ?
                        <div>
                         <text style={{color:"#999999",fontSize:12}}>确认失败时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                       </div>:
                       <div>
                         {
                             item.confirmState ==="1" || item.confirmState ==="2" ?
                             <text style={{color:"#999999",fontSize:12}}>确认成功时间  {item.confirmDateStr ? this.timeFormat(item.confirmDateStr): "--"}</text>
                             :
                             null
                         }
                       </div>
                      }
                </div>
                :
                <div style={{flex:1,flexDirection:"row"}}>
                </div>
                  }
                  <text style={{color:"#333333"}}>{item.trustChannelName}</text>
                </div>
            </div>
               )
           })
           }
           </div>
         </div>
         </div>
         { timeAll?
          <DownUpList1 titleItem = '交易' chulihanshu={this.jyTypeCallback.bind(this)}  listContent = {[
            {title: '选择业务类型', callback:('')},
            {title: '转换', callback: ('36')},
            {title: '申购', callback:('22')},
            {title: '赎回', callback: ('24') },
            // {title: '分红', callback: ('029') },
          ]} />
          :null
        } 
        </div>
    
    )
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
    shareToInfo:state.shareToInfo,
  }
}
export default connect(mapStateToProps)(Detailsofwarehouseadjustment);
export class DownUpList1 extends Component{
  constructor(props){
    super(props);
    this.state = {
    }
  }
  render(){
    let listContent = this.props.listContent;
    let listArray = [];
    for(let i = 0 ; i < listContent.length; i++){
      listArray.push(
        <div key = {i} className="contentContainer" onClick = {()=>this.props.chulihanshu(listContent[i].title, listContent[i].callback) } >
              <div  style = {{color:"#333333"}} >{listContent[i].title}</div>
        </div>
      )
    }
    return (
      <div className="containertiaocang">
           <div className="scrollView">
            {
              listArray
            }
          </div>
        <div style = {{flex:1}}  onClick = {this.props.cancelCallback}>
        </div>
       
      </div>
    );
  }
}
const styles ={
  container:{
    flex: 1
  },
  scrollView: {
    flex: 1,
    width:"100%",
  },
  title: {
    color: '#5b6370',
    fontSize: 13,
    // fontFamily: 'Microsoft YaHei'
  },
  contentContainer: {
    justifyContent: 'center',
    display: "-webkit-flex",
    alignItems: 'center',
    width: "100%",
    height: 52,
    backgroundColor: '#ffffff',
  },
};


// WEBPACK FOOTER //
// ./src/components/fundDetail/Detailsofwarehouseadjustment.js